// ─────────────────────────────────────────────────────────────────────────────
// StatsRow.js — the four KPI tiles. Owns the mapping from the metrics payload to
// tile props, so index.js never touches the API shape and the icon/colour/stagger
// for a KPI lives in exactly one place.
// ─────────────────────────────────────────────────────────────────────────────
import { ReactComponent as NodesIcon }     from "../../../assets/icons/nodes.svg";
import { ReactComponent as BandwidthIcon } from "../../../assets/icons/bandwith.svg";
import { ReactComponent as SessionIcon }   from "../../../assets/icons/session.svg";
import { ReactComponent as ThreatsIcon }   from "../../../assets/icons/threatsB.svg";
import { formatDelta } from "../../../services/dashboardService";
import StatCard, { StatCardSkeleton } from "./StatCard";
import styles from "./StatsRow.module.css";

// One entry per tile — order here is the order on screen.
const KPIS = [
  { key: "active_nodes",     label: "Active Nodes",     icon: <NodesIcon />,     color: "#00e87a", delay: 0   },
  { key: "global_bandwidth", label: "Global Bandwidth", icon: <BandwidthIcon />, color: "#00c8e8", delay: 80,  float: true, withUnit: true },
  { key: "active_sessions",  label: "Active Sessions",  icon: <SessionIcon />,   color: "#a855f7", delay: 160 },
  { key: "threats_blocked",  label: "Threats Blocked",  icon: <ThreatsIcon />,   color: "#ffc542", delay: 240 },
];

export default function StatsRow({ metrics }) {
  return (
    <div className={styles.row}>
      {metrics
        ? KPIS.map(({ key, withUnit, ...kpi }) => {
            const m = metrics[key];
            return (
              <StatCard
                key={key}
                {...kpi}
                value={m?.value ?? 0}
                unit={withUnit ? m?.unit ?? "" : undefined}
                {...formatDelta(m?.delta_percent)}
              />
            );
          })
        : KPIS.map((kpi) => <StatCardSkeleton key={kpi.key} />)}
    </div>
  );
}
